export const ONE_MI_IN_KM = 1.609344;

export const UNIT_KM = 'km';
export const UNIT_MI = 'mi';
